<template>
  <div>
    <BannerHeroCaseStudy
      title="Great Southern Credit Management"
      desc="Discover how Aussie Broadband helped bring three companies and office locations together with an internet and hosted phone solution that was both flexible and scalable."
      img-src="/img/logos/company/great-southern-credit-management-sq.webp"
      img-alt="Great Southern Credit Management logo"
    />

    <section class="container spacing-color">
      <TabsSlots :data="accordionData">
        <template #challenge>
          <TabsContentTemplatesCaseStudy :data="slotData.challenge" />
        </template>
        <template #solution>
          <TabsContentTemplatesCaseStudy :data="slotData.solution" />
        </template>
        <template #result>
          <TabsContentTemplatesCaseStudy :data="slotData.result" />
        </template>
      </TabsSlots>
    </section>

    <BannerEbook segment="business" ebook="sdWan" class="spacing-white" />

    <section id="contact" class="container spacing-white">
      <FormBusinessGeneric
        heading="Get in touch"
        title="Tap into our tech expertise"
        desc="Talk to our team about tech solutions that help boost your bottom line."
      />
    </section>
  </div>
</template>
<script setup lang="ts">
const accordionData = [
  {
    id: "challenge",
    label: "The challenge",
    icon: resolveComponent("IconChallenge"),
  },
  {
    id: "solution",
    label: "The solution",
    icon: resolveComponent("IconSolution"),
  },
  {
    id: "result",
    label: "The result",
    icon: resolveComponent("IconResult"),
  },
];

const slotData = {
  challenge: {
    title: "The challenge",
    preQuote: [
      "The Great Southern Credit Management (GSCM) group originally consisted of the following 3 individual businesses specialising in the provision of debt prevention, credit management and debt collection services:",
      {
        type: "ul" as "ul" | "ol" | "h3",
        content: [
          "<span class='font-semibold'>Provincial Credit Solutions (PCS)</span> - based in Warrnambool, Victoria, and est. in 2001.",
          "<span class='font-semibold'>Barwon Credit Management (BCM)</span> - based in Geelong, Victoria, and est. in 2005.",
          "<span class='font-semibold'>Von Doussa Credit Management Services (VON)</span> - based in Adelaide, South Australia, and est. circa 1960.",
        ],
      },
      "After a transition period of approximately 2 years, these three companies have come together to be now known as Great Southern Credit Management Pty Ltd.",
      "Great Southern Credit Management needed a solution to bring all three of these companies and office locations together. To achieve this, they required a telecommunications provider that understood their needs and could deliver a wide area network (WAN), Internet and hosted telephone system that was both flexible and scalable.",
    ],
  },
  solution: {
    title: "The solution",
    preQuote: [
      "Aussie Broadband were able to design and implement a Wide Area Network (WAN) with connectivity to each Great Southern Credit Management office including a central internet connection with a managed firewall using their National MPLS backbone and last mile connections delivered from Aussie Broadband owned and maintained infrastructure and wholesale partner owned and maintained infrastructure.",
      "The solution included Aussie Broadband sourcing, configuring and professionally installing Cisco customer premises equipment (CPE) to allow for class leading flexibility, scalability and the highest of security for the network.",
      "The solution also included rolling out a corporate grade Hosted Telephony system consisting of approximately 20 Cisco handsets across all offices. This gave Great Southern Credit Management the ability to setup queuing and accept incoming calls at any office, reduce costs by receiving free calls between all offices, have voicemail delivered as an email to their inbox and to divert their extension to their mobile on the fly among other features.",
      "Great Southern Credit Management have access to the Aussie Broadband Business Portal, and from within this purpose built portal, Great Southern Credit Management have full visibility into current and historical service bandwidth utilization as well as the ability to see data usage for all services across their organization with usage updating every 15 minutes.",
      "The Aussie Broadband Business Portal is feature rich and fully equipped with all the information a customer needs to monitor their services in one central system. This portal alleviated the need for Great Southern Credit Management to invest resources into a system to manage their own WAN.",
    ],
  },
  result: {
    title: "The result",
    preQuote: [
      "Having a custom built, flexible, scalable WAN and a hosted telephony system designed to meet their specific business needs has allowed Great Southern Credit Management to focus on running their business, which has resulted in a better experience for their employees and in term their customers.",
    ],
    quote: {
      text: "The Aussie Broadband team from the sales people, pre sales engineers, technicians and over the phone support personal have done a fantastic job of implementing our new network and phone system. They continue to provide class leading backup service and network, phone system and firewall changes are made in a timely fashion.",
      name: "Mark Bridge",
      role: "Managing Director",
      company: "Great Southern Credit Management",
    },
    postQuote: [
      "Great Southern Credit Management is an organisation with offices in multiple states with very specific telecommunications needs and Aussie Broadband is proud to have been chosen to implement their WAN, Internet and phone solution.",
    ],
  },
};

const metaStore = useMetaStore();
metaStore.pageTitle = "Great Southern Credit Management | Aussie Broadband";
metaStore.metaTitle = "Great Southern Credit Management With Aussie Broadband";
metaStore.metaDescription =
  "Discover how Aussie Broadband helped bring three companies and office locations together with an internet and hosted phone solution that was both flexible and scalable.";
</script>
